import store from "@/store";
import { getStorage, removeStorage, setStorage } from "@/utils/storage";
import router, { fullyRouted } from "./index";
import matchWhitelist from "./whitelist";
import createMessageBox from "@/tools/prompt-window";
import { userBecome, emailBuriedPoint } from "@/api/feedback";
import { Loading } from "element-ui";
import {setZendeskAutoHide} from "@/utils/zendesk";
import { unloadApplication, getAppStatus } from "single-spa";
import {systemInfo, OnBoarding$} from "@/shared-services";
import { temporaryToken, getTokenByTl } from '@/api/user'
import {mfRegister, mfWalletRegister} from "@/tl-mf-config";
import { exportBySearch } from '@/tools/basic-methods'
import { getDialerCondition as getDialerConditionApi } from '@/api/dialer'
import { getCards as getCardsApi } from '@/api/card'

let routersList = [];
window.globalLoadingInstance = null;

// 登陆不重定向到的路由列表
let redirectBlacklist = [
  /^\/reactive(\/.*)?$/,
  /^\/beta-account(\/.*)?$/,
  /^\/onboarding(\/.*)?$/
]

function isShowPopup(route) {
  let role = store.getters['user/role']
  let subscription_status = store.getters['user/subscription_status']
  let showPopupList = [
    /^\/feedback(\/.*)?$/,
    /^\/self-order(\/.*)?$/,
    /^\/setting\/add-card(\/.*)?$/,
    /^\/setting\/update-subscription(\/.*)?$/,
    /^\/setting\/subscription-and-billing(\/.*)?$/,
  ]
  let bool = false
  if (role === 'admin' && 
    subscription_status === 'not finished' && 
    !showPopupList.some(i => i.test(route.path)) && bool
  ) {
    createMessageBox()
  }
}

function isExpiredTrialAccount(path) {
  let expiredTrialAccountWhiteList = [
    /^\/self-order(\/.*)?$/,
    /^\/setting\/subscription-and-billing(\/.*)?$/,
    /^\/setting\/subscription-and-billing-v2(\/.*)?$/,
    /^\/reactive(\/.*)?$/,
    /^\/login(\/.*)?$/,
    /^\/setting\/update-subscription(\/.*)?$/,
    /^\/setting\/update-subscription-v2(\/.*)?$/,
    /^\/setting\/add-card(\/.*)?$/,
    /^\/404(\/.*)?$/,
    /^\/401(\/.*)?$/,
  ]
  return store.state.user.demoType === 'trial' &&
    store.state.user.expiredTrialAccount &&
    !expiredTrialAccountWhiteList.some(item => item.test(path))
}

export function generateRoutes() {
  return store.dispatch('permissionV2/generateRoutes').then(res => {
    // router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.
    res.routes.forEach(route => {
      router.addRoute(route)
    })
    res.fullyRoutes.forEach(route => {
      fullyRouted.addRoute(route)
    })
  })
}

function isExpiredTrialBetaAccount(path) {
  let expiredBetaAccountWhiteList = [
    /^\/beta-account\/extend(\/.*)?$/,
    /^\/login(\/.*)?$/,
    /^\/404(\/.*)?$/,
    /^\/401(\/.*)?$/,
  ]
  return store.state.user.demoType === 'demo' &&
    store.state.user.expiredDemoAccount &&
    !expiredBetaAccountWhiteList.some(item => item.test(path))
}

// beta延长15天后过期的用户
function isExpiredTrialBetaTrialAccount(path) {
  let expiredBetaTrialAccountWhiteList = [
    /^\/setting\/subscription-and-billing(\/.*)?$/,
    /^\/setting\/subscription-and-billing-v2(\/.*)?$/,
    /^\/beta-account\/reactive(\/.*)?$/,
    /^\/login(\/.*)?$/,
    /^\/setting\/update-subscription(\/.*)?$/,
    /^\/setting\/update-subscription-v2(\/.*)?$/,
    /^\/setting\/add-card(\/.*)?$/,
    /^\/404(\/.*)?$/,
    /^\/401(\/.*)?$/,
  ]
  return store.state.user.demoType === 'demo_trail' &&
    store.state.user.expiredTrialAccount &&
    !expiredBetaTrialAccountWhiteList.some(item => item.test(path))
}


// 权限控制
// 注意：如果重定向一定要reutrn null
function accessControl(to, from, next, replace) {
  isShowPopup(to)
  if (isExpiredTrialAccount(to.path)) {
    // 如果是过期的试用用户，则重定向到reactive
    next('/reactive')
    return null
  } else if (isExpiredTrialBetaAccount(to.path)) {
    // 如果是过期的beta用户，则重定向到/beta-account/extend
    next('/beta-account/extend')
    return null
  } else if (isExpiredTrialBetaTrialAccount(to.path)) {
    // 如果beta用户延长15天后再过期，则重定向到/beta-account/reactive
    next('/beta-account/reactive')
    return null
  } else if (to.name === 'dashboard' && store.state.user.onboardingShow === 1 && !sessionStorage.getItem("enterOnboarding") && to.path !== '/onboarding/index') {
    sessionStorage.setItem("enterOnboarding", true)
    // 页面关闭token未过期，下次进入不进onboarding问题
    next('/onboarding/index')
    return null
  } else if (replace) {
    next({ ...to, replace: true })
  } else {
    next()
  }
  return true
}

let zendeskTime = null
function initZendesk(to) {
  try {
    if (window.zE) {
      let user = store.state.user
      clearInterval(zendeskTime)
      zendeskTime = null
      window.zE('webWidget', 'prefill', {
        name: {
          value: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : ''
        },
        email: {
          value: user.email || ''
        }
      })
      // window.zE('webWidget', 'show')
      if (/^\/map(\/.*)?$/.test(to.path)) {
        store.dispatch("user/updateShowSupportStatus", false)
      } else {
        store.dispatch("user/updateShowSupportStatus", true)
      }
      setZendeskAutoHide()
    } else if (!zendeskTime) {
      zendeskTime = setInterval(() => {
        initZendesk(to)
      }, 300)
    }
  } catch (e){
    console.error(e)
  }
}

async function getDialerCondition(to) {
  try {
    if (/^\/load-board\/search-loads(\/.*)?$/.test(to.path)) {
      let result = await getDialerConditionApi()
      store.dispatch('user/updateDialerCondition', result.data)
    }
  } catch (error) {
    console.error('getDialerCondition:', error)
  }
}

async function getCards(to) {
  try {
    let list = [
      /^\/load-board\/search-loads(\/.*)?$/,
      /^\/map\/index(\/.*)?$/,
    ]
    if (list.some(item => item.test(to.path))) {
      let { res } = await getCardsApi()
      store.dispatch("user/updateHasCard", Boolean(res.data.data.default))
      OnBoarding$.subscribe(s => s.updateHasCard({
        hasCard: Boolean(res.data.data.default)
      }))
    }
  } catch (error) {
    console.error('getCards:', error)
  }
}

/** 
 * 注意
 * 
 * 重定向的路由在next后必须return，否则zendesk会在不该展示的页面展示
 * 
 * 
*/

if (systemInfo.isCommand) {
  router.beforeEach(async(to, from, next) => {
    if (
      // to.fullPath.startsWith("/load-board") ||
      // (from.fullPath.startsWith("/load-board") && from.fullPath !== "/")
      to.meta &&
      to.meta.system &&
      to.meta.system === "carrier"
    ) {
      try {
        const status = getAppStatus("@tl-mf/carrier");
        if (status === "MOUNTED") unloadApplication("@tl-mf/carrier");
      } catch (error) {
        // no application
        console.error("single-spa!", error);
      }
    }
    if (
      to.meta &&
      to.meta.system &&
      to.meta.system === "dispatch"
    ) {
      try {
        const status = getAppStatus("@tl-mf/dispatch");
        if (status === "MOUNTED") unloadApplication("@tl-mf/dispatch");
      } catch (error) {
        // no application
        console.error("single-spa!", error);
      }
    }
    if(routersList.indexOf(to.path) === -1) {
      routersList.push(to.path)
      window.globalLoadingInstance = Loading.service(
        {
          lock: true,
          text: '',
          customClass:'global-loading-container'
        }
      );
    }
    let queryObj = exportBySearch(location.search)
    if (queryObj.tlTrialToken && !getStorage()) {
      let { res } = await getTokenByTl({token: queryObj.tlTrialToken})
      if (res && res.data && res.data.data && res.data.data.token) {
        setStorage(res.data.data.token);
        window.location.href = location.origin + location.pathname
        next()
        return;
      }
    }
    console.log(to, from , queryObj, '123123123')
    console.log('im 1')
    if (to.query.emailToken && to.query.from) {
      emailBuriedPoint(to.query);
      next(to.path)
      return;
    }
    if (to.query.token) {
      let {res} = await userBecome({
        token: to.query.token
      })
      if (res.data.data) setStorage(res.data.data);
    }
    const token = getStorage();
    if (!token) {
      // if there is no token in command, we need to logout carrier use
      mfRegister(null, true);
      mfWalletRegister(null, true);
    }
    console.log(token, 'token')
    if (/^\/signature\/t(\/.*)?$/.test(to.path)) {
      next()
      return null
    }
    if (matchWhitelist(to.path)) {
      if (/^\/login(\/.*)?$/.test(to.path)) {
        window.globalLoadingInstance && window.globalLoadingInstance.close();
        window.globalLoadingInstance = null;
        next('/')
        return null
      } 
      if (token) {
        const hasRole = store.getters["user/role"]
        await getDialerCondition(to)
        await getCards(to)
        if (!hasRole) {
          try {
            await store.dispatch("user/getUser")
            await generateRoutes()
            next()
            return null
          } catch(error) {
            if (getStorage()) {
              removeStorage();
              removeStorage('IMAuth')
              removeStorage('encryptKey')
              removeStorage('x-portal-token')
              removeStorage('x-user-readOnly')
              sessionStorage.removeItem('qboIntegrationConnectedUrlStorage')
              sessionStorage.removeItem('_payItemData')
              sessionStorage.removeItem("timestampFlag");
              sessionStorage.removeItem("enterOnboarding")
            }
          }
        } else {
          next()
          return null
        }
      }

      if (!getStorage('commandTemporaryToken')) {
        let {data} = await temporaryToken()
        if (data.token) setStorage(data.token, 'commandTemporaryToken')
      }
      store.dispatch("permissionV2/addRouterToBar")
      next();
    } else if (token) {
      console.log('im 3')
      const hasRole = store.getters["user/role"]
      const reacquire = store.getters["user/reacquire"]
      await getDialerCondition(to)
      await getCards(to)
      if (hasRole && !reacquire) {
        console.log('im 4')
        if (!accessControl(to, from, next)) return null
        initZendesk(to)
      } else {
        // 拆分前端后端报错
        try {
          await store.dispatch("user/getUser")
        } catch(error) {
          console.log('me-error:', error)
          // me接口报错，页面会刷新，导致报错文案无法展示6秒中，所以需要在登陆页展示
          if (error.status !== 401) {
            sessionStorage.setItem('meError', JSON.stringify(error))
          }
          return store.dispatch("user/logout")
        }
        try {
          console.log('im 5x ')
          await generateRoutes()
          if (!accessControl(to, from, next, true)) return null
          initZendesk(to)
        } catch(error) {
          console.log('im 6')
          console.log(error)
          return store.dispatch("user/logout")
        }
      }
    } else if (redirectBlacklist.some(item => item.test(to.path))) {
      next('/login')
      return null
    } else {
      // debugger;
      // map会存在直接打开的路由参数，重定向后不需要
      if(to.path !== "/" ){
        next(`/map/index?isLogin=true&redirect=${to.path !== '/map' ? to.fullPath : ''}`)
      }else{
        next(`/map/index?redirect=${to.path !== '/map' ? to.fullPath : ''}`)
      }
      return null
    }
    // 是否展示右下角聊天机器人
    // if (window.zE) {
    //   if (window.zendeskWhitelist.some(item => item.test(to.path))) {
    //     window.zE('webWidget', 'show')
    //   } else {
    //     window.zE('webWidget', 'close')
    //     window.zE('webWidget', 'hide')
    //   }
    // }
  })
  router.afterEach((to) => {
    window.globalLoadingInstance && window.globalLoadingInstance.close();
    window.globalLoadingInstance = null;
    if(/^\/payments(\/.*)?$/.test(to.path)) {
      let hasViewedPayments = localStorage.getItem(`has_reviewed_payments_${store.state.user.userId}`)
      if (hasViewedPayments !== 'YES') {
        localStorage.setItem(`has_reviewed_payments_${store.state.user.userId}`, 'YES')
        store.dispatch('permissionV2/updateRoutes')
      }
    }
    if(/^\/dashboardv2(\/.*)?$/.test(to.path)) {
      let hasViewedDashboard = localStorage.getItem(`has_reviewed_dashboard_${store.state.user.userId}`)
      if (hasViewedDashboard !== 'YES') {
        localStorage.setItem(`has_reviewed_dashboard_${store.state.user.userId}`, 'YES')
        store.dispatch('permissionV2/updateRoutes')
      }
    }
  })

}
